<template>
  <el-dialog
    width="650px"
    top="12vh"
    title="信息审核记录"
    :visible.sync="showVisible"
    :close-on-click-modal="false"
    class="detail-info-dia">
    <div class="scroll-wrap">
      <vue-scroll :ops="disScrollOpt" ref="vScroll">
        <div class="timeline">
          <div class="timeline-item" v-for="(audit, i) in audit_msg" :key="audit.audit_id">
            <div class="item_tail" v-show="i !== audit_msg.length-1"></div>
            <div class="item_node" v-if="audit.audit_type ==='audit_info'">
              {{audit.status | translate}}
            </div>
            <div class="item_node" v-else>
              提交
            </div>
            <div class="item_wrap">
              <div class="timestamp">
                <span>{{audit.create_time | time}}</span>
                <!-- <span class="audit_people" v-if="audit.audit_type ==='audit_info'">
                  审核人：{{audit.unit_name | userRole}}（{{audit.user_name}}）
                </span>
                <span class="audit_people" v-else>
                  提交人：{{audit.unit_name}}（{{audit.user_name}}）
                </span> -->
              </div>
              <div class="item_cont">
                <p>
                  <span>
                    {{audit.audit_type | transType}}
                  </span>
                  <span v-if="audit.audit_type === 'audit_info'">
                    ：{{audit.status | translate}}
                  </span>
                </p>
                <p v-if="audit.audit_type === 'audit_info'">
                  理由 ：{{audit.msg_info || '--'}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </vue-scroll>
    </div>
  </el-dialog>
</template>

<script>
import ops from "@/assets/js/vuescrollOption";
import { user_audit_list } from '@/api/common/api'
import {roleHash} from "@/assets/js/status";
const filterHash = {
  "pass": "通过",
  "wait": "待审核",
  "refused": "拒绝"
};
const filterType = {
  "submit_info": '提交信息',
  "audit_info": "审核信息"
}
  export default {
    props: {
      show: {
        request: true,
        type: Boolean
      },
      userId: {
        request: true,
        type: Number
      }
    },
    data() {
      return {
        disScrollOpt: ops(true),
        audit_msg: []
      }
    },
    computed: {
      showVisible: {
        get () {
          if (this.show)  this.getList()
          return this.show
        },
        set (val) {
          this.$emit('flag',val)
        }
      }
    },
    filters: {
      translate(str) {
        return filterHash[str];
      },
      transType(type) {
        return filterType[type]
      },
      userRole: (role) => roleHash[role],
    },
    methods: {
      getList(){
        user_audit_list({user_id: this.userId}).then(({data}) => {
          if (data.status === 0){
            this.audit_msg = data.result.auditList
          }
        })
      }
    }
  }
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.detail-info-dia
  .scroll-wrap
    display block
    height 400px
    overflow hidden
    position relative
    .timeline {
      display block
      padding-top 5px
      margin-right 20px
      .timeline-item {
        position relative
        padding-bottom 20px
        .item_tail {
          position absolute
          top 36px
          bottom 6px
          left 16px
          // height 100%
          border-left 2px solid #000
        }
        .item_node {
          position absolute
          background-color #fff
          color #333
          border 1px solid #000
          border-radius 50%
          // left -2px
          width 36px
          height @width
          font-size: 12px;
          display flex
          align-items center
          text-align: center;
          justify-content center
        }
        .item_wrap {
          position: relative;
          padding-left: 50px;
          top: -3px;
          .timestamp {
            display flex
            // align-items center
            line-height 1
            margin-bottom 5px
            font-size 15px
            .audit_people {
              flex 1
              text-align right
              margin-left 10px
            }
          }
          .item_cont {
            display block
            background-color #fff
            color #333
            padding 10px
            border-radius: 4px;
            border: 1px solid #cccccc;
            overflow: hidden;
            font-size:15px;
            box-shadow 0 2px 12px 0 rgba(255,255,255,.1)
          }
        }
      }
    }
</style>